import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MeasurementTypes } from "src/api/types";

interface Props {
  measurements: MeasurementTypes;
}

const Measurements = ({ measurements }: Props) => {
  const { t } = useTranslation();
  const component = "weight-tracker";

  return (
    <Stack direction={"row"} spacing={6}>
      <Stack gap={1}>
        <Typography variant="subtitle1">
          {t(`${component}.current-weight`, "Current")}
        </Typography>
        <Typography variant="h5" fontWeight={600}>
          {measurements.current ? `${measurements.current} lbs` : "-"}
        </Typography>
      </Stack>
      <Stack gap={1}>
        <Typography variant="subtitle1">
          {t(`${component}.start-weight`, "Start")}
        </Typography>
        <Typography variant="h5" fontWeight={600}>
          {measurements.starting} lbs
        </Typography>
      </Stack>
    </Stack>
  );
};

export default Measurements;
